
export const LogEventName = {
    openAppPage: 'open_app_page',
    openApp: 'open_app',
    downloadApp: 'download_app',
    findDoctor: 'find_doctor',
    findDoctorByScanning: 'find_doctor_by_scanning',
    findDoctorByFavorites: 'find_doctor_by_favorites',
    findDoctorByRecentSearches: 'find_doctor_by_recent_searches',
    findDoctorByPopularSearches: 'find_doctor_by_popular_searches',
    bookAppointment: 'book_appointment',
    favoriteDoctor: 'favorite_doctor',
    cancelFavoriteDoctor: 'cancel_favorite_doctor',
    share: 'share',
    sendFeedback: 'send_feedback',
    submitVitalSign: 'submit_vital_sign',
    clickNearestForSorting: 'click_nearest_for_sorting',
    clickApplyFilter: 'click_apply_filter',
    clickBookAppointment: 'click_book_appointment',
}
